import DOMPurify from "dompurify";

/**
 * sanitizes user input to prevent script injection attacks
 * @param input - the user input string to sanitize
 * @returns sanitized string with potentially dangerous content removed
 */
export function sanitizeInput(input: string): string {
  if (!input || typeof input !== "string") {
    return "";
  }

  // first, manually remove dangerous protocols
  const sanitizedInput = input.replace(/javascript:/gi, "");

  // use DOMPurify to remove any HTML/script tags and dangerous content
  return DOMPurify.sanitize(sanitizedInput, { ALLOWED_TAGS: [] });
}

/**
 * sanitizes user input while preserving basic formatting (line breaks, basic text)
 * @param input - the user input string to sanitize
 * @returns sanitized string with basic formatting preserved but scripts removed
 */
export function sanitizeInputWithBasicFormatting(input: string): string {
  if (!input || typeof input !== "string") {
    return "";
  }

  // allow only basic text formatting, no scripts or HTML
  return DOMPurify.sanitize(input, {
    ALLOWED_TAGS: ["br", "p"],
    ALLOWED_ATTR: [],
  });
}
